export default __webpack_public_path__ + "static/media/Organizational_Excellence_ribbon.198138d2.jpg";